<template>
  <div>
    <div class="overllay-popups" v-if="showFirstPopup || showSliderOne || showSliderTwo">

    </div>
    <div class="q-pa-lg  direction-popup" v-if="showFirstPopup">
      <div class=" items-center justify-center column full-height no-wrap full-width">
        <h2 class="fs-2 q-mx-auto text-weight-bold q-mb-md">
          مرحباً بك في منصة أكواد
        </h2>
        <p class="fs-6 text-primary">
          منصة التقييم الرقمي الأولى
        </p>
        <div class="row full-width items-center justify-center q-mt-lg">
          <div class="box-choise q-ma-lg cursor-pointer" @click="choiseBoard(2)">
            <div class="q-px-md q-py-lg row items-center justify-center">
              <span class="col-3">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M28.0003 13.3307C27.987 8.55073 27.8483 6.03473 26.1457 4.4214C24.2897 2.66406 21.3057 2.66406 15.3337 2.66406C9.36299 2.66406 6.37633 2.66406 4.52166 4.4214C2.66699 6.17873 2.66699 9.00806 2.66699 14.6641C2.66699 20.3201 2.66699 23.1494 4.52166 24.9067C6.15766 26.4561 8.67099 26.6401 13.3337 26.6614M20.0003 23.3307C20.0003 23.3307 20.667 23.3307 21.3337 24.6641C21.3337 24.6641 23.451 21.3307 25.3337 20.6641"
                    stroke="#5854FF" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M2.66699 11.3281H28.0003M8.66699 7.32812H8.67899M14.0003 7.32812H14.0123M29.3337 22.6615C29.3337 24.4296 28.6313 26.1253 27.381 27.3755C26.1308 28.6257 24.4351 29.3281 22.667 29.3281C20.8989 29.3281 19.2032 28.6257 17.9529 27.3755C16.7027 26.1253 16.0003 24.4296 16.0003 22.6615C16.0003 20.8933 16.7027 19.1977 17.9529 17.9474C19.2032 16.6972 20.8989 15.9948 22.667 15.9948C24.4351 15.9948 26.1308 16.6972 27.381 17.9474C28.6313 19.1977 29.3337 20.8933 29.3337 22.6615Z"
                    stroke="#5854FF" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
              <div class="fs-md col-9">
                <p class="q-my-md">قيّم موقعك مع أكواد</p>
                <p class="q-my-md">احصل على تحليلًا احترافيا لموقعك</p>
              </div>
            </div>
          </div>
          <div class="box-choise q-mx-lg cursor-pointer" @click="choiseBoard(1)">
            <div class="q-px-md q-py-lg row items-center justify-center">
              <span class="col-3">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.6669 27.3307H6.78694C4.72694 27.3307 3.08827 26.3281 1.61761 24.9267C-1.39573 22.0561 3.55094 19.7627 5.43761 18.6401C8.41631 16.8796 11.9349 16.2661 15.3336 16.9147M22.9216 17.4347L23.8603 19.3281C23.9399 19.4699 24.0485 19.5934 24.179 19.6906C24.3094 19.7878 24.4589 19.8564 24.6176 19.8921L26.3189 20.1761C27.4069 20.3587 27.6629 21.1547 26.8789 21.9401L25.5563 23.2734C25.4403 23.4047 25.3553 23.5602 25.3073 23.7286C25.2593 23.897 25.2496 24.0741 25.2789 24.2467L25.6576 25.8974C25.9563 27.2041 25.2683 27.7094 24.1216 27.0267L22.5269 26.0747C22.3638 25.9901 22.1827 25.9459 21.9989 25.9459C21.8152 25.9459 21.6341 25.9901 21.4709 26.0747L19.8763 27.0267C18.7349 27.7094 18.0416 27.1987 18.3403 25.8974L18.7189 24.2467C18.7483 24.0741 18.7386 23.897 18.6906 23.7286C18.6426 23.5602 18.5575 23.4047 18.4416 23.2734L17.1189 21.9401C16.3416 21.1547 16.5923 20.3587 17.6789 20.1761L19.3803 19.8921C19.5382 19.8556 19.6866 19.7864 19.8162 19.6891C19.9457 19.5917 20.0534 19.4683 20.1323 19.3267L21.0709 17.4334C21.5829 16.4067 22.4149 16.4067 22.9216 17.4334M18.6669 6.66406C18.6669 7.45199 18.5117 8.23221 18.2102 8.96016C17.9087 9.68812 17.4667 10.3496 16.9096 10.9067C16.3524 11.4639 15.691 11.9058 14.963 12.2073C14.2351 12.5089 13.4549 12.6641 12.6669 12.6641C11.879 12.6641 11.0988 12.5089 10.3708 12.2073C9.64289 11.9058 8.98145 11.4639 8.4243 10.9067C7.86715 10.3496 7.42519 9.68812 7.12366 8.96016C6.82214 8.23221 6.66694 7.45199 6.66694 6.66406C6.66694 5.07276 7.29908 3.54664 8.4243 2.42142C9.54952 1.2962 11.0756 0.664062 12.6669 0.664062C14.2582 0.664062 15.7844 1.2962 16.9096 2.42142C18.0348 3.54664 18.6669 5.07276 18.6669 6.66406Z"
                    stroke="#5854FF" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                </svg>


              </span>
              <div class="fs-md col-9">
                <p class="q-my-md"> كن مقيمًا مع أكواد
                </p>
                <p class="q-my-md">شارك في تحسين التجارب الرقمية</p>
              </div>

            </div>
          </div>


        </div>

        <q-btn style="align-self:end" label="أعرضه لي لاحقا " class=" q-ma-sm q-px-md text-primary" size="md"
          @click="hideAllPopups(true, 1)" />
      </div>
    </div>

    <div class="q-pa-lg explanation-board  " v-if="showSliderOne">
      <div class="items-center justify-center column full-height no-wrap full-width ">
        <q-carousel swipeable v-model="slide" ref="carousel" class="full-width">
          <q-carousel-slide :name="1" class="column no-wrap flex-center full-width ">
            <div class="row iteme-center justify-center full-width ">
              <div class="column items-start justify-center  col-md-6 col-12  ">
                <h2 class="fs-4 text-weight-bold q-mb-md text-primary ">
                  قم بتحميل أداة "أكواد"
                </h2>
                <p class="fs-6  ">
                  كي يتم قبول تقييمك تحتاج الى تحميل أداة أكواد من متجر قوقل
                </p>
              </div>
              <div class="col-md-6 col-12 img-slider-container">
                <img src="@/assets/images/board/slider-1-1.png" alt="" loading="lazy">
              </div>
            </div>
          </q-carousel-slide>
          <q-carousel-slide :name="2" class="column no-wrap flex-center full-width">
            <div class="row iteme-center justify-center full-width">
              <div class="column items-start justify-center  col-md-6 col-12  ">
                <h2 class="fs-4 text-weight-bold q-mb-md text-primary ">
                  كي يتم إعتمادك ك "مقيم خبير" </h2>
                <p class="fs-6  ">
                  تحتاج الى إكمال 10 تقييمات ذات قيمة عالية في تخصصك
                  ليتم اعتمادك كمقيم خبير في المنصة </p>
              </div>
              <div class="col-md-6 col-12 img-slider-container">
                <img src="@/assets/images/board/slider-1-2.png" alt="" loading="lazy">
              </div>
            </div>
          </q-carousel-slide>
          <q-carousel-slide :name="3" class="column no-wrap flex-center full-width">
            <div class="row iteme-center justify-center full-width">
              <div class="column items-start justify-center  col-md-6 col-12  ">
                <h2 class="fs-4 text-weight-bold q-mb-md text-primary ">
                  احصل على الطلبات وزد دخلك

                </h2>
                <p class="fs-6  ">
                  قدّم تقييماتك الاحترافية وابدأ باستقبال الطلبات</p>
              </div>
              <div class="col-md-6 col-12 img-slider-container">
                <img src="@/assets/images/board/slider-1-3.png" alt="" loading="lazy">
              </div>
            </div>
          </q-carousel-slide>
          <q-carousel-slide :name="4" class="column no-wrap flex-center full-width">
            <div class="row iteme-center justify-center full-width">
              <div class="column items-start justify-center  col-md-6 col-12  ">
                <h2 class="fs-4 text-weight-bold q-mb-md text-primary ">
                  أدر مهامك وتقييماتك بسهولة
                </h2>
                <p class="fs-6  ">
                  تابع طلبات التقييم ونفذها عبر أداة أكواد المخصصة لك
                </p>
              </div>
              <div class="col-md-6 col-12 img-slider-container">
                <img src="@/assets/images/board/slider-1-4.png" alt="" loading="lazy">
              </div>
            </div>
          </q-carousel-slide>



          <template v-slot:control>
            <div class="footer-actions">
              <q-carousel-control>
                <div class="row">
                  <q-btn v-if="slide == 1" @click="showChoisingPopup()" label="أعد الاختيار" class=" q-ma-sm q-px-md text-primary"
                    size="md" />

                  <q-btn v-if="slide != 1"  outline color="primary" label="السابق"
                    class="rounded-8 q-pa-md q-px-md next-prev" size="md" @click="$refs.carousel!.previous()" />

                </div>
                <div class="row justify-end">
                  <q-btn outline v-if="slide != 4" color="primary" label="التالي" class="rounded-8  q-pa-md  next-btn"
                    @click="$refs.carousel!.next()" size="md" />

                  <q-btn outline @click="goToJoinExpert()" v-if="slide == 4" color="primary" label="أبدأ "
                    class="rounded-8  q-pa-md  next-btn" />

                  <q-btn label="أعرضه لي لاحقا " class=" q-ma-sm q-px-md text-primary" size="md"
                    @click="hideAllPopups(true, 2)" />

                </div>
              </q-carousel-control>
            </div>
          </template>
        </q-carousel>

      </div>
    </div>
    <div class="q-pa-lg explanation-board  " v-if="showSliderTwo">
      <div class="items-center justify-center column full-height no-wrap full-width">
        <q-carousel swipeable v-model="slideTwo" ref="carousel">
          <q-carousel-slide :name="1" class="column no-wrap flex-center full-width">
            <div class="row iteme-center justify-center full-width">
              <div class="column items-start justify-center  col-md-6 col-12  ">
                <h2 class="fs-4 text-weight-bold q-mb-md text-primary ">
                  احصل على تقييمات حقيقية
                </h2>
                <p class="fs-6  ">
                  تقييمات حقيقية من مستخدمين فعليين وتجارب مباشرة
                </p>
              </div>
              <div class="col-md-6 col-12 img-slider-container">
                <img src="@/assets/images/board/slider-2-1.png" alt="" loading="lazy">
              </div>
            </div>
          </q-carousel-slide>
          <q-carousel-slide :name="2" class="column no-wrap flex-center full-width">
            <div class="row iteme-center justify-center full-width">
              <div class="column items-start justify-center  col-md-6 col-12  ">
                <h2 class="fs-4 text-weight-bold q-mb-md text-primary ">
                  اكتشف ملاحظات الخبراء </h2>
                <p class="fs-6  ">
                  تعرف على سلوك الخبراء كمستخدمين فعليين لموقعك
                  لتعرف أين تواجههم التحديات بوضوح </p>
              </div>
              <div class="col-md-6 col-12 img-slider-container">
                <img src="@/assets/images/board/slider-2-2.png" alt="" loading="lazy">
              </div>
            </div>
          </q-carousel-slide>
          <q-carousel-slide :name="3" class="column no-wrap flex-center full-width">
            <div class="row iteme-center justify-center full-width">
              <div class="column items-start justify-center  col-md-6 col-12  ">
                <h2 class="fs-4 text-weight-bold q-mb-md text-primary ">
                  اختبر استجابة موقعك
                </h2>
                <p class="fs-6  ">
                  خبراء معتمدين لإختبار استجابة موقعك على مختلف الأجهزة
                  والمتصفحات </p>
              </div>
              <div class="col-md-6 col-12 img-slider-container">
                <img src="@/assets/images/board/slider-2-3.png" alt="" loading="lazy">
              </div>
            </div>
          </q-carousel-slide>
          <q-carousel-slide :name="4" class="column no-wrap flex-center full-width">
            <div class="row iteme-center justify-center full-width">
              <div class="column items-start justify-center  col-md-6 col-12  ">
                <h2 class="fs-4 text-weight-bold q-mb-md text-primary ">
                  قم بتحميل أداة "أكواد"
                </h2>
                <p class="fs-6  ">
                  للاطلاع على تقييمات الخبراء وملاحظاتهم حول موقعك
                </p>
              </div>
              <div class="col-md-6 col-12 img-slider-container">
                <img src="@/assets/images/board/slider-2-4.png" alt="" loading="lazy">
              </div>
            </div>
          </q-carousel-slide>
          <q-carousel-slide :name="5" class="column no-wrap flex-center full-width">
            <div class="row iteme-center justify-center full-width">
              <div class="column items-start justify-center  col-md-6 col-12  ">
                <h2 class="fs-4 text-weight-bold q-mb-md text-primary ">
                  احصل على تقارير أداء الموقع
                </h2>
                <p class="fs-6  ">
                  تقارير احترافية توضّح نقاط القوة والضعف في موقعك
                </p>
              </div>
              <div class="col-md-6 col-12 img-slider-container">
                <img src="@/assets/images/board/slider-2-5.png" alt="" loading="lazy">
              </div>
            </div>
          </q-carousel-slide>



          <template v-slot:control>
            <div class="footer-actions">
              <q-carousel-control>
                <div class="row">
                  <q-btn   v-if="slideTwo == 1"  @click="showChoisingPopup()" label="أعد الاختيار" class=" q-ma-sm q-px-md text-primary"
                    size="md" />

                  <q-btn v-if="slideTwo != 1"  outline color="primary" label="السابق"
                    class="rounded-8 q-pa-md q-px-md next-prev" size="md" @click="$refs.carousel!.previous()" />

                </div>
                <div class="row justify-end">
                  <q-btn outline v-if="slideTwo != 5" color="primary" label="التالي"
                    class="rounded-8  q-pa-md  next-btn" @click="$refs.carousel!.next()" size="md" />

                  <q-btn outline @click="goToJoinOrderPage()" v-if="slideTwo == 5" color="primary" label="أبدأ "
                    class="rounded-8  q-pa-md  next-btn" />

                  <q-btn label="أعرضه لي لاحقا " class=" q-ma-sm q-px-md text-primary" size="md"
                    @click="hideAllPopups(true, 3)" />

                </div>
              </q-carousel-control>
            </div>
          </template>
        </q-carousel>

      </div>
    </div>

  </div>

</template>

<script lang="ts" setup>

import { ref, onMounted } from 'vue';
import { QCarousel, useQuasar, QBtn, QCarouselSlide } from 'quasar';
import { useRouter } from 'vue-router';

const slide = ref(1)
const slideTwo = ref(1)

const showFirstPopup = ref(false);
const showSliderOne = ref(false);
const showSliderTwo = ref(false);
const router = useRouter();

const dataOnBoard = ref<any>({
  tabShow: 1,
  isComplete: false,
  howMuchReloadBeforShow: 0,
})

const $q = useQuasar();
const choiseBoard = (plan: number) => {
  showFirstPopup.value = false;
  if (plan == 1) showSliderOne.value = true
  else if (plan == 2) showSliderTwo.value = true
}

const showChoisingPopup = () => {
  showFirstPopup.value = true;
  showSliderOne.value = false
  showSliderTwo.value = false
}

const goToJoinExpert = () => {
  hideAllPopups(false, 0);
  router.push('/verified-reviewer');
  dataOnBoard.value.isComplete = true;
  $q.localStorage.set('onBoard', dataOnBoard.value)

}

const goToJoinOrderPage = () => {
  hideAllPopups(false, 0);
  router.push('/subscription');

  dataOnBoard.value.isComplete = true;
  $q.localStorage.set('onBoard', dataOnBoard.value)
}

const hideAllPopups = (showAgain = true, page: number) => {
  showFirstPopup.value = false;
  showSliderOne.value = false
  showSliderTwo.value = false

  if (showAgain) {
    if (page != 0) {
      dataOnBoard.value.tabShow = page
    }
    dataOnBoard.value.howMuchReloadBeforShow = 3;
    $q.localStorage.set('onBoard', dataOnBoard.value)
  }

}




onMounted(() => {


  let data = $q.localStorage.getItem('onBoard')

  if (!data) {
    $q.localStorage.set('onBoard', dataOnBoard.value)
  } else {
    dataOnBoard.value = data;
  }

  if (!dataOnBoard.value.isComplete) {
    console.log(dataOnBoard.value.howMuchReloadBeforShow)
    if (dataOnBoard.value.howMuchReloadBeforShow == 0) {
      if (dataOnBoard.value.tabShow == 1) showFirstPopup.value = true;
      else if (dataOnBoard.value.tabShow == 3) showSliderTwo.value = true
      else if (dataOnBoard.value.tabShow == 2) showSliderOne.value = true
    } else {
      dataOnBoard.value.howMuchReloadBeforShow = dataOnBoard.value.howMuchReloadBeforShow - 1
      $q.localStorage.set('onBoard', dataOnBoard.value)
    }
  }
  // let objOnBoard = JSON.parse

})

</script>

<style lang="scss"> 
.overllay-popups {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #33333375;
  z-index: 99999;
}

.direction-popup {
  .box-choise {
    max-width: 280px;
    min-width: 280px;
    border-radius: 20px;
    border: 1px solid #5854ff;
    transition: all 0.2s ease-in-out;
    -webkit-transition: all 0.2s ease-in-out;

    &:hover {
      background: #5854ff;

      p {
        color: var(--bs-body-bg);
      }

      svg path {
        stroke: white;
      }
    }
  }
}

.explanation-board,
.direction-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  background: white;
  z-index: 999999;
  width: 50%;
  min-width: 720px;
  height: auto;
  min-height: 400px;
  max-height: 90vh;
  border-radius: 20px;
  box-shadow: rgb(50 50 93 / 22%) 0px 0px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  overflow: visible;

  .q-carousel.q-panel-parent {
    width: 100%;
    height: 100%;
    min-height: 400px;
  }
}

.direction-popup {
  @media (max-width: 768px) {
    min-width: 90%;
    width: 90%;
    max-width: 500px;
    padding: 16px;

    .box-choise {
      min-width: 100%;
      max-width: 100%;
      margin: 8px 0;
    }
  }
}

.explanation-board {
  @media (max-width: 768px) {
    min-width: 95%;
    width: 95%;
    max-width: 500px;
    padding: 12px;
  }

  @media (max-width: 556px) {
    min-width: 98%;
    width: 98%;
    max-width: 350px;
    padding: 8px;
  }
}

.explanation-board .q-carousel.q-panel-parent.q-carousel--without-padding {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  min-height: 400px;
}

.explanation-board .q-carousel__control.absolute-bottom-right {
  margin: 0 !important;
  position: relative !important;
  bottom: auto !important;
  right: auto !important;
}

.explanation-board .next-btn {
  background: #5854ff !important;
  color: white !important;
  padding-inline: 26px !important;
}
.explanation-board .next-prev {
  padding-inline: 26px !important;
}

.explanation-board .q-carousel__slides-container {
  width: 100%;
  flex: 1;
}

.explanation-board .q-carousel__slide {
  padding-block: 40px;

  @media (max-width: 768px) {
    padding-block: 20px;

    .row {
      flex-direction: column;

      .col-md-6 {
        width: 100%;
        margin-bottom: 20px;

        &:first-child {
          order: 1;
        }

        &:last-child {
          order: 2;
        }
      }
    }
  }
}

.explanation-board img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}

.explanation-board .img-slider-container {
  width: 100%;
  max-width: 400px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    height: 200px;
    max-width: 300px;
    margin: 0 auto;
  }
}

.footer-actions {
  width: 100%;
  margin-top: 20px;

  >div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;

    @media (max-width: 768px) {
      // flex-direction: column;

      .row {
        // width: 100%;
        justify-content: center;
        margin: 5px 0;

        &.justify-end {
          justify-content: center;
        }
      }
    }
    @media (max-width: 480px) {
       flex-direction: column;

      .row {
         width: 100%;
      }
    }
  }
}

// إضافة دعم Safari للـ flexbox
.row,
.column {
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
}

.column {
  flex-direction: column;
  -webkit-box-orient: vertical;
}

.items-center {
  align-items: center;
  -webkit-box-align: center;
}

.justify-center {
  justify-content: center;
  -webkit-box-pack: center;
}

.justify-end {
  justify-content: flex-end;
  -webkit-box-pack: end;
}

.full-width {
  width: 100%;
}

.full-height {
  height: 100%;
}

// إصلاح مشاكل Safari والـ iOS
.no-wrap {
  flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
}

// تحسين عرض الـ SVG في Safari
svg {
  display: block;
  max-width: 100%;
  height: auto;
}

// إصلاح مشكلة الـ transform في Safari
.explanation-board,
.direction-popup {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

// تحسين الانتقالات في Safari
* {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

// إصلاح مشكلة الـ positioning في iOS
@supports (-webkit-touch-callout: none) {

  .explanation-board,
  .direction-popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    -webkit-transform: translate3d(-50%, -50%, 0);
  }
}

// تحسين الاستجابة للشاشات الصغيرة
@media screen and (max-width: 480px) {

  .direction-popup,
  .explanation-board {
    width: 95vw;
    height: auto;
    max-height: 90vh;
    min-width: unset;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .direction-popup .box-choise {
    min-width: 100%;
    max-width: 100%;
  }

  .explanation-board .img-slider-container {
    height: 150px;
    max-width: 250px;
  }

  .footer-actions .row {
    flex-direction: column;
    gap: 10px;
  }
}

// إصلاح مشاكل الخط العربي في iOS
.fs-2,
.fs-4,
.fs-6,
.fs-md {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

// تحسين أداء الكاروسيل في Safari
.q-carousel {
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}

// إصلاح مشكلة الـ z-index في Safari
.overllay-popups {
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}
</style>